import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormControlErrorMessageComponent } from './form-control-error-message.component';

@NgModule({
  imports: [
    CommonModule,
    MatFormFieldModule
  ],
  declarations: [
    FormControlErrorMessageComponent
  ],
  exports: [
    FormControlErrorMessageComponent
  ]
})
export class FormControlErrorMessageModule { }
